"use client";
import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function TermsOfService() {
  return (
    <>
      <div
        className="w-full py-16 px-6 md:px-12"
        style={{
          backgroundColor: "var(--nhs-pale-grey)",
          color: "var(--nhs-black)",
        }}
      >
        <div className="max-w-4xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center mb-8 px-4 py-3 font-bold no-underline"
            style={{
              color: "var(--nhs-dark-blue)",
              backgroundColor: "var(--nhs-white)",
              border: "2px solid var(--nhs-dark-blue)",
              boxShadow: "0 3px 0 var(--nhs-dark-blue)",
            }}
          >
            <span aria-hidden="true" className="mr-2">
              ←
            </span>
            Back to home
          </Link>
          <h1
            className="text-4xl font-bold mb-2"
            style={{ color: "var(--nhs-dark-blue)" }}
          >
            Terms of Service
          </h1>

          <p className="text-sm mb-6" style={{ color: "var(--nhs-dark-grey)" }}>
            Last updated: 13 December 2025
          </p>

          <p className="text-lg mb-8">
            These Terms of Service govern the use of systems, services, and
            platforms operated by Prince George University Hospital (PGUH). By
            accessing or using PGUH services, you agree to these terms.
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">Acceptable use</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Use PGUH services lawfully and responsibly</li>
              <li>Do not attempt unauthorised access to systems or data</li>
              <li>Do not submit false, misleading, or harmful information</li>
              <li>Do not disrupt or compromise service availability</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">Accounts and access</h2>
            <p>
              Some services may require approval or verification. PGUH reserves
              the right to approve, restrict, suspend, or revoke access at its
              discretion.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">Intellectual property</h2>
            <p>
              All content, branding, and materials provided by PGUH remain the
              property of PGUH unless otherwise stated. Unauthorised use is
              prohibited.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">Service availability</h2>
            <p>
              PGUH aims to provide reliable access but does not guarantee
              uninterrupted service. Services may be updated or withdrawn
              without notice.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">Limitation of liability</h2>
            <p>
              PGUH is not liable for any loss or damage arising from the use of
              its services, except where liability cannot be excluded under UK
              law.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">Governing law</h2>
            <p>These terms are governed by the laws of England and Wales.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">Contact</h2>
            <p>
              Questions regarding these terms can be sent to{" "}
              <a
                href="mailto:pguh.co.uk@gmail.com"
                className="font-semibold underline"
                style={{ color: "var(--nhs-dark-blue)" }}
              >
                pguh.co.uk@gmail.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
}
